import { http } from "@/lib/http";

import type {
  DnsRecordSet,
  DnsRecordSetCreateRequest,
  DnsRecordSetUpdateRequest,
  DnsZone,
  DnsZoneCreateRequest,
  DnsZoneUpdateRequest,
  FloatingIPPtr,
  FloatingIPPtrSetRequest,
  ZoneExportResult,
  ZoneImportRequest,
  ZoneImportResult,
} from "./types";

export async function listZones(): Promise<DnsZone[]> {
  const { data } = await http.get<DnsZone[]>("/dns/zones");
  return data;
}

export async function getZone(zoneId: string): Promise<DnsZone> {
  const { data } = await http.get<DnsZone>(`/dns/zones/${zoneId}`);
  return data;
}

export async function createZone(
  payload: DnsZoneCreateRequest,
): Promise<DnsZone> {
  const { data } = await http.post<DnsZone>("/dns/zones", payload);
  return data;
}

export async function deleteZone(zoneId: string): Promise<void> {
  await http.delete(`/dns/zones/${zoneId}`);
}

export async function exportZone(zoneId: string): Promise<ZoneExportResult> {
  const { data } = await http.post<ZoneExportResult>(
    `/dns/zones/${zoneId}/export`,
  );
  return data;
}

export async function importZone(
  payload: ZoneImportRequest,
): Promise<ZoneImportResult> {
  const { data } = await http.post<ZoneImportResult>(
    "/dns/zones/import",
    payload,
  );
  return data;
}

export async function updateZone(
  zoneId: string,
  payload: DnsZoneUpdateRequest,
): Promise<DnsZone> {
  const { data } = await http.put<DnsZone>(`/dns/zones/${zoneId}`, payload);
  return data;
}

export async function listRecordsets(zoneId: string): Promise<DnsRecordSet[]> {
  const { data } = await http.get<DnsRecordSet[]>(
    `/dns/zones/${zoneId}/recordsets`,
  );
  return data;
}

export async function createRecordset(
  zoneId: string,
  payload: DnsRecordSetCreateRequest,
): Promise<DnsRecordSet> {
  const { data } = await http.post<DnsRecordSet>(
    `/dns/zones/${zoneId}/recordsets`,
    payload,
  );
  return data;
}

export async function updateRecordset(
  zoneId: string,
  recordsetId: string,
  payload: DnsRecordSetUpdateRequest,
): Promise<DnsRecordSet> {
  const { data } = await http.put<DnsRecordSet>(
    `/dns/zones/${zoneId}/recordsets/${recordsetId}`,
    payload,
  );
  return data;
}

// --- floating-IP reverse DNS (PTR) ---

export async function listFloatingIpPtrs(): Promise<FloatingIPPtr[]> {
  const { data } = await http.get<FloatingIPPtr[]>("/dns/ptr/floatingips");
  return data;
}

export async function setFloatingIpPtr(
  floatingipId: string,
  payload: FloatingIPPtrSetRequest,
): Promise<FloatingIPPtr> {
  const { data } = await http.put<FloatingIPPtr>(
    `/dns/ptr/floatingips/${floatingipId}`,
    payload,
  );
  return data;
}

export async function unsetFloatingIpPtr(floatingipId: string): Promise<void> {
  await http.delete(`/dns/ptr/floatingips/${floatingipId}`);
}

export async function deleteRecordset(
  zoneId: string,
  recordsetId: string,
): Promise<void> {
  await http.delete(`/dns/zones/${zoneId}/recordsets/${recordsetId}`);
}
